import dynamic from 'next/dynamic';

const CustomError = dynamic(() => import('./CustomError'));

export default CustomError
